/**
 * @ngdoc directive
 * @module components.sticky
 * @name components.sticky:sticky
 * @scope
 * @restrict E
 * @description
 * Used for elements that stick to the top of the defined scrollable region when the user scrolls past the element. Do note that there is an issue with how the sticky element displays caused by differences in how this page is structured with our typical front end.
 * @param {string} scrollTarget Selector for the scrollable element that will be stuck to.
 * @param {function=} onStick Callback triggered when sticky element starts sticking. (not implemented)
 * @param {function=} onRelease Callback triggered when sticky element stops sticking. (not implemented)
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div id="content" ng-controller="exampleController">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac condimentum neque, vitae faucibus ipsum. Ut porttitor justo nec ante ultricies, eget luctus massa porta. Curabitur pellentesque consequat nulla in tempor. Nullam rutrum odio non mattis sagittis. Vestibulum tincidunt enim vitae ex ultrices, id finibus quam tincidunt. Vivamus hendrerit lorem vitae diam porta luctus. Mauris fermentum imperdiet tempus. Fusce eu lacus est. Curabitur vel condimentum enim, sit amet auctor urna. Nam volutpat enim enim, vel egestas justo fermentum hendrerit. Donec sagittis tincidunt accumsan. Donec feugiat tempor orci. Maecenas condimentum ligula at accumsan fermentum. Integer cursus tellus non dictum condimentum.</p>
                <sticky scroll-target="#content">
                    <h3>Testing things</h3>
                </sticky>
                <p>Cras lacinia iaculis ex, eu laoreet turpis semper ac. In vulputate sagittis sem nec laoreet. Nunc nec ornare sapien. Nam quis lectus felis. Pellentesque at eros accumsan, tincidunt lorem quis, aliquam leo. Integer in aliquet dolor. Integer interdum posuere dignissim. Donec commodo ligula a quam mattis, quis pharetra neque porta. Morbi facilisis ligula vitae ligula dignissim, at sollicitudin nibh ultrices. Proin at facilisis magna. Sed fermentum varius pulvinar. Fusce iaculis nibh eu mi rutrum egestas in vel felis. Suspendisse pulvinar ante vel ante ullamcorper maximus.</p>
                <p>Vivamus urna est, convallis nec aliquam et, dictum a erat. Praesent nunc est, viverra sit amet urna ac, eleifend tincidunt ligula. Praesent porta luctus tellus vel gravida. Ut leo lorem, finibus et rhoncus in, ornare at sapien. Aenean mi nibh, accumsan maximus volutpat sit amet, tincidunt in erat. Morbi eros tellus, ullamcorper vitae odio sed, egestas placerat nunc. Morbi ac lacinia felis. Integer posuere facilisis turpis at sollicitudin. Donec odio tellus, posuere eget neque et, imperdiet lobortis ligula. Aliquam quis dolor rhoncus, iaculis lacus tempus, pellentesque turpis. Cras lobortis leo sit amet magna ullamcorper semper. Proin gravida neque id metus commodo congue. Praesent condimentum, quam imperdiet pulvinar convallis, ex tellus tincidunt sapien, quis vulputate ex nulla quis eros.</p>
                <p>Donec ornare lectus sit amet ipsum scelerisque, eu varius nisi tincidunt. Pellentesque vestibulum justo eget risus commodo, sed vehicula magna consequat. Etiam mollis risus sit amet magna pellentesque hendrerit. Donec ut lorem tincidunt, semper massa in, pretium mauris. Quisque in tincidunt est, et finibus dolor. Aenean ac dolor eu mi laoreet suscipit vitae sed ipsum. Curabitur placerat varius lorem ac rutrum. Fusce in nibh et magna luctus vulputate. Pellentesque sit amet dictum magna, vitae molestie nunc. Morbi iaculis sapien mollis nulla blandit convallis. In a elementum elit. Sed vel dolor condimentum lectus lacinia accumsan quis vitae diam.</p>
                <p>Duis lectus libero, tempor quis neque ut, feugiat lacinia ex. Nunc sed tortor eget lacus bibendum congue. Sed eget mi sit amet elit volutpat tempus et quis nunc. Mauris id aliquam nulla. Phasellus cursus scelerisque mi. Nulla a suscipit quam. Sed eleifend odio non tellus tincidunt iaculis. Mauris nec tortor justo. Fusce pretium, velit at ultricies mattis, justo elit ultricies nibh, a elementum metus nibh rhoncus lorem. Pellentesque vitae nunc vel ante facilisis aliquet tincidunt et dolor. Etiam ante augue, laoreet ac elit vitae, tristique vestibulum ipsum. Vivamus faucibus mauris non nunc convallis, interdum interdum enim sodales. Cras ipsum neque, dignissim eu vestibulum et, tincidunt non odio. Morbi non ornare odio. Duis dignissim, sem at vehicula porttitor, libero lorem finibus turpis, nec pharetra neque augue ut eros.</p>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.sticky'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                }
            })();
        </file>
        <file name="style.css">
            #content {
                height: 600px;
                overflow: auto;
            }
        </file>
    </example>
 */
(function () {
    angular.module('components.sticky', [])
        .component('sticky', {
            bindings: {
                scrollTarget: '@',
                restrict: '@?',
                prioritize: '<?',
                onInit: '&?',
                onStick: '&?',
                onRelease: '&?'
            },
            require: {
                stickyManager: '?^^stickyManager',
                stickyContainer: '?^^stickyContainer'
            },
            template: '<div class="sticker" ng-class="{sticking: $ctrl.sticking, released: $ctrl.released}"><div class="content" ng-transclude></div></div><div class="spacer"></div>',
            transclude: true,
            controller: stickyController
        });

    stickyController.$inject = ['$element', '$window', '$scope', '$timeout'];
    var id = 0;
    function stickyController($element, $window, $scope, $timeout) {
        var ctrl = this;
        ctrl.$id = id++;
        ctrl.$onInit = function () {
            ctrl.sticking = false;
            ctrl.stickyManager.registerSticky(ctrl.$id, $element, ctrl);
        };
        ctrl.$postLink = function () {
            ctrl.$sticker = $element.find('>.sticker');
            ctrl.$content = ctrl.$sticker.find('> .content');
            ctrl.$spacer = $element.find('>.spacer');
            ctrl.$spacer.height(ctrl.$content.outerHeight());
            ctrl.$scrollTarget = ctrl.scrollTarget ? angular.element(ctrl.scrollTarget) : angular.element($window);
            ctrl.$scrollTarget.on('scroll.sticky', ctrl.$$asyncUpdateSticky);
            ctrl.$window = angular.element($window).on('resize.sticky', function () {
                ctrl.$$updateSticky(true);
            });
            $timeout(function () {
                ctrl.$$updateSticky();
                if (ctrl.onInit) {
                    ctrl.onInit({
                        sticking: ctrl.sticking,
                        element: $element
                    });
                }
            });
        };

        ctrl._stylesReadyCheck = function (resolve, reject) {
            if ($element.css('display') !== 'inline') {
                resolve();
            }
            else {
                $timeout(function () {
                    ctrl._stylesReadyCheck(resolve, reject);
                }, 100);
            }
        };

        ctrl.$$asyncUpdateSticky = function () {
            $scope.$evalAsync(ctrl.$$updateSticky);
        };

        ctrl.$$updateSticky = function (forceUpdate) {
            ctrl.released = ctrl.$$isReleased();
            if (!ctrl.released) {
                var newSticky = ctrl.$$isSticky();
                if (newSticky !== ctrl.sticking || forceUpdate) {
                    ctrl.sticking = newSticky;
                    ctrl.$$updateStyling();
                }
            }
            ctrl.$content.css({
                maxHeight: ctrl.sticking ? 'calc(100vh - ' + ((ctrl.scrollTarget ? ctrl.$scrollTarget.offset().top : 0) + (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint(ctrl.$id) : 0)) + 'px)' : ''
            });
        };

        ctrl.$$isSticky = function () {
            if (ctrl.restrict && !Foundation.MediaQuery.atLeast(ctrl.restrict)) {
                return false;
            }
            var offset = $element[0].getBoundingClientRect().top + parseInt($element.css('padding-top')) + parseInt($element.css('margin-top'));
            var topOffset = (ctrl.scrollTarget ? ctrl.$scrollTarget.offset().top : 0) + (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint(ctrl.$id) : 0);
            return offset <= topOffset;
        };

        ctrl.$$isReleased = function () {
            if (!ctrl.stickyContainer || (ctrl.restrict && !Foundation.MediaQuery.atLeast(ctrl.restrict))) {
                return false;
            }
            return ctrl.$content.outerHeight() >= ctrl.stickyContainer.getBottom() - (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint(ctrl.$id) : 0);
        };

        ctrl.$$updateStyling = function () {
            var elementOffset = $element[0].getBoundingClientRect();
            ctrl.$sticker.css({
                left: ctrl.sticking ? elementOffset.left : '',
                width: ctrl.sticking ? elementOffset.width : '',
                top: ctrl.sticking ? (ctrl.scrollTarget ? ctrl.$scrollTarget.offset().top : 0) + (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint(ctrl.$id) : 0) : ''
            });
            var height = ctrl.$content.outerHeight();
            ctrl.$spacer.height(height);
        };

        ctrl.$onDestroy = function () {
            ctrl.$scrollTarget.off('scroll.sticky');
            ctrl.$window.off('resize.sticky');
        };
    }
})();